import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import RichText from "../../Prismic/RichText";
import Button from "wonderbly-components/lib/Button";
import { prismicImage } from "src/common/utils/prismic-image";

import Magnifier from "../../Magnifier";

import "./Stacked.scss";

const getImage = (item, productId) => {
  const halfWidth = Math.round(item.image.dimensions.width / 2);
  const actualWidth = item.enableMagnifier
    ? item.image.dimensions.width
    : halfWidth;
  const imageUrl = prismicImage(item.image, {
    width: actualWidth,
  });
  return (
    <Magnifier
      active={item.enableMagnifier}
      imageUrl={imageUrl}
      productId={productId}
    >
      <img src={imageUrl} alt={item.image.alt} width={halfWidth} />
    </Magnifier>
  );
};

const Stacked = (props) => (
  <section className="product-information-stacked" id={props.id}>
    {props.items.map((item, i) => (
      <div key={`product-information-${i}`} className="product-information">
        <div className="container-guttered">
          <div className="product-information-wrapper">
            <div className="product-information-image">
              {getImage(item, props.productId)}
            </div>
            <div className="product-information-content">
              <h3 className="text-giga">{item.title}</h3>
              <RichText fields={item.description} />
              {!isEmpty(props.link) && (
                <Button onClick={props.handleClick}>{props.cta}</Button>
              )}
            </div>
          </div>
        </div>
      </div>
    ))}
  </section>
);

Stacked.propTypes = {
  id: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  cta: PropTypes.string,
  link: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.array.isRequired,
      enableMagnifier: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

export default Stacked;
